import React from "react";
import { Container } from "react-bootstrap";
import {
  FaInfoCircle,
  FaShieldAlt,
  FaLock,
  FaChartLine,
  FaCogs,
  FaUsers,
  FaDesktop,
  FaSyncAlt,
  FaEnvelope,
  FaFileAlt
} from "react-icons/fa";
import "./TNC.css";

const CookiePolicy = () => {
  return (
    <div className="tnc-container">
      <Container>
        <div className="tnc-wrapper">
          {/* Header Section */}
          <div className="tnc-header">
            {/* <div className="brand-logo">
              <span className="logo-text-white">F</span>
              <span className="logo-text-pink">T</span>
              <span className="logo-text-white">unes</span>
            </div> */}
            <h1 className="main-title">
              <span className="text-yellow">Cookie</span>{" "}
              <span className="text-pink">Policy</span>
            </h1>
            <p className="intro-text">
              This Cookie Policy explains how FT Tunes uses cookies and similar
              technologies to recognize visitors when they use our website and
              services. It explains what these technologies are and why we use
              them.
            </p>
          </div>

          {/* Section 1 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number purple-gradient">1</span>
              <FaInfoCircle className="section-icon-inline mr-2 text-purple" />{" "}
              What Are Cookies?
            </h2>
            <p className="section-text">
              Cookies are small data files stored on your device when you visit a
              website. Cookies help websites function efficiently and improve user
              experience by remembering preferences and activity.
            </p>
          </div>

          {/* Section 2 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number orange-gradient">2</span>
              <FaCogs className="section-icon-inline mr-2 text-orange" />{" "}
              How We Use Cookies
            </h2>
            <p className="section-text mb-2">FT Tunes uses cookies to:</p>
            <ul className="custom-list mb-3">
              <li>Keep users logged into their accounts</li>
              <li>Improve website performance</li>
              <li>Understand visitor behavior and analytics</li>
              <li>Enhance security and prevent fraud</li>
              <li>Remember user preferences</li>
            </ul>
          </div>

          {/* Section 3 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number pink-gradient">3</span>
              <FaFileAlt className="section-icon-inline mr-2 text-pink" />{" "}
              Types of Cookies We Use
            </h2>
            <p className="section-text mb-2">
              <strong>Essential Cookies:</strong> Required for website
              functionality such as login, navigation, and security.
            </p>
            <p className="section-text mb-2">
              <strong>Performance Cookies:</strong> Help us analyze traffic and
              improve website performance.
            </p>
            <p className="section-text mb-2">
              <strong>Functional Cookies:</strong> Store user settings and
              personalization preferences.
            </p>
            <p className="section-text">
              <strong>Analytics Cookies:</strong> Used to understand how visitors
              interact with our website using tools like analytics services.
            </p>
          </div>

          {/* Cards grid for smaller sections */}
          <div className="cards-grid-2">
            {/* Section 4 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number blue-gradient">4</span>
                <FaUsers className="section-icon-inline mr-2 text-blue" />{" "}
                Third-Party Cookies
              </h2>
              <p className="section-text">
                Some cookies may be set by third-party services such as analytics
                providers, streaming platforms, payment processors, or embedded
                content providers.
              </p>
            </div>

            {/* Section 5 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number green-gradient">5</span>
                <FaDesktop className="section-icon-inline mr-2 text-green" />{" "}
                Managing Cookies
              </h2>
              <p className="section-text">
                Users can control or delete cookies through their browser
                settings. Disabling cookies may affect certain features and
                functionality of the website.
              </p>
            </div>
          </div>

          {/* Cards grid for smaller sections */}
          <div className="cards-grid-2">
            {/* Section 6 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number red-gradient">6</span>
                <FaLock className="section-icon-inline mr-2 text-red" />{" "}
                Data Protection
              </h2>
              <p className="section-text">
                Cookies do not typically contain personally identifiable
                information but may be linked with personal data stored by FT
                Tunes in accordance with our Privacy Policy.
              </p>
            </div>

            {/* Section 7 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number purple-gradient">7</span>
                <FaSyncAlt className="section-icon-inline mr-2 text-purple" />{" "}
                Policy Updates
              </h2>
              <p className="section-text">
                We may update this Cookie Policy from time to time to reflect
                legal, technical, or operational changes.
              </p>
            </div>
          </div>

          {/* Section 8 */}
          <div className="policy-section transparent-bg mb-0 pb-0">
            <h2 className="section-title contact-title">
              <span className="section-number pink-gradient">8</span> Contact Us
            </h2>
            <div className="contact-grid-tnc">
              <div className="contact-address-box card-gradient-border">
                <h3 className="address-title">FT Tunes</h3>
                <p className="address-line">If you have questions about our</p>
                <p className="address-line">Cookie Policy, please contact</p>
                <p className="address-line">FT Tunes.</p>
              </div>
              <div className="contact-details-box">
                <div className="contact-item">
                  <div className="contact-icon purple-bg">
                    <FaEnvelope />
                  </div>
                  <div>
                    <div className="contact-label">Email</div>
                    <div className="contact-value">music@fttunes.com</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </Container>
    </div>
  );
};

export default CookiePolicy;